import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP, BACKEND_API_URL } from "@/utils/http-common"

export default {
  getAll(eventId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/event/${eventId}/reservations`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },

  get($, eventId = null, reservationId = null, uuid = null) {
    return new Promise((resolve, reject) => {
      let root
      if (uuid) {
        root = `/event/reservations/${uuid}`
      } else if (eventId) {
        root = `/event/${eventId}/reservations${reservationId ? "/" + reservationId : ""}`
      } else {
        root = `/event/reservations${reservationId ? "/" + reservationId : ""}`
      }
      HTTP.get(root)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },

  async getAllReservations() {
    const path = `/event/reservations`
    return (await HTTP.get(path)).data
  },

  async closeExpired(eventId = null) {
    const path = `/event/reservations/close-expired`
    return (await HTTP.post(path, eventId ? { event: eventId } : {})).data
  },

  remove($, reservationId) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/event/reservations/${reservationId}`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },

  create($, eventId, reservation) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/event/${eventId}/reservations`, reservation)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  update($, reservationId, reservation) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/event/reservations/${reservationId}`, reservation)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  createInspection($, eventId, reservation) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/event/${eventId}/reservations`, reservation)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("app/message", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  getPayments($, reservationId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/event/${reservationId}/payments`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("app/message", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  getCalendar($, eventId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/event/${eventId}/reservations/calendar`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("app/message", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  getAllCalendar($, eventId = null) {
    const params = {}
    if (eventId) params.event = eventId
    return new Promise((resolve, reject) => {
      HTTP.get(`/event/reservations/calendar`, params)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("app/message", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  createPayment($, reservationId, reservation) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/event/${reservationId}/payments`, reservation)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("app/message", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  updatePayment($, reservationId, paymentId, reservation) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/event/reservations/${reservationId}/payments/${paymentId}`, reservation)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("app/message", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  getReceiptUrl($, reservationId, paymentId) {
    return new Promise((resolve, reject) => {
      const url = `${BACKEND_API_URL}/event/reservations/${reservationId}/payments/${paymentId}/receipt`

      // Prepare request
      let xhr = new XMLHttpRequest()
      xhr.open("GET", url, true)
      xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key)
      xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName)
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (xhr.status === 200) resolve(xhr.response)
        else reject(xhr)
      }

      // Execute request
      xhr.send()
    })
  },
  getContractUrl($, reservationId) {
    return new Promise((resolve, reject) => {
      const url = `${BACKEND_API_URL}/event/reservations/${reservationId}/contract`
      const xhr = new XMLHttpRequest()
      xhr.open("GET", url, true)
      xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key)
      xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName)
      xhr.responseType = "blob"
      xhr.onload = () => (xhr.status === 200 ? resolve(xhr.response) : reject(xhr))
      xhr.send()
    })
  },
  document: {
    async get($, reservationId) {
      const path = `/documents/reservations/${reservationId}`
      const response = (await HTTP.get(path)).data
      if (response.length > 0) {
        return response[0]
      } else {
        throw Error("No template linked")
      }
    },
    async post(reservationId, data) {
      const path = `/documents/reservations/${reservationId}`
      return (await HTTP.post(path, data)).data
    },
    async put(reservationId, data) {
      const path = `/documents/reservations/${reservationId}`
      return (await HTTP.put(path, data)).data
    }
  },
  unassignedPictures: {
    getAll(reservationId) {
      return new Promise((resolve, reject) => {
        HTTP.get(`/event/reservations/${reservationId}/unassigned-pictures`)
          .then(response => resolve(response.data))
          .catch(err => {
            return reject(err)
          })
      })
    },
    create(reservationId, data) {
      return new Promise((resolve, reject) => {
        HTTP.post(`/event/reservations/${reservationId}/unassigned-pictures`, data)
          .then(response => resolve(response.data))
          .catch(err => {
            return reject(err)
          })
      })
    }
  }
}
